import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Row, TextLabel } from '../../atoms';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { useBreakpoints } from '../../hooks';
function MainFooterComponent({ items }) {
    const { breakpoints } = useBreakpoints(500);
    return (_jsx(Row.R, { p: "4", style: [
            $.container,
            breakpoints.LESS_THAN_M && $.container_S,
            breakpoints.XS && $.container_XS,
        ], children: items.map(item => (_jsx(TextLabel, { href: item.url, onPress: item.onPress, lhFull: true, children: item.label }, item.label))) }));
}
const $ = StyleSheet.create({
    container: {
        borderTopWidth: 1,
        borderTopColor: theme.color.border.primary,
        gap: theme.spacing['6'],
    },
    container_S: {
        gap: theme.spacing['4'],
    },
    container_XS: {
        justifyContent: 'center',
    },
});
export const MainFooter = memo(MainFooterComponent);
MainFooter.displayName = 'MainFooter';
